import { Component, OnInit } from '@angular/core';
import {ChartDataSets, ChartOptions, ChartType} from 'chart.js';
import {Color, Label, SingleDataSet} from 'ng2-charts';
import {ChartService} from '../services/chart.service';
import * as Chart from 'chart.js';

@Component({
  selector: 'app-my-chart',
  templateUrl: './my-chart.component.html',
  styleUrls: ['./my-chart.component.css']
})
export class MyChartComponent implements OnInit {
  public proVersion = 'false';
  public isPremium;
  public langMode = 'fa';
  public tab = 'tab3';
  public thisWeek = [];
  public lastWeek = [];
  public average = [];
  public thisWeekTotalAverage;
  public lastsWeekTotalAverage;
  public averageTotalAverage;
  public hoh;
  public barChartLabelsFarsi: Label[] = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه'];
  public barChartLabelsEnglish: Label[] = ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];
  public legend: {};
  public barChartData: ChartDataSets[] = [];
  public chartColors: Array<any> = [];
  // Pie Chart
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      labels: {
        fontFamily: 'IRANSansFarsi !important',
        fontSize: 15,
      }
    }
  };
  public pieChartLabels: Label[] = [];
  public pieChartData: SingleDataSet = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartColors = [
    {
      backgroundColor: ['#DC143C', '#DC1483', '#B414DC', '#3314DC', '#14C0DC', '#14DC9B', '#ABDC14', '#DCA814', '#DC7014', '#353535'],
    },
  ];
  public pieChartPlugins = [];
  public barChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      labels: {
        fontStyle: 'IRANSansFarsi !important',
        fontFamily: 'IRANSansFarsi !important',
        fontSize: 30,
      }
    }
  };
  // Line Chart
  public lineChartData: ChartDataSets[] = [];
  public lineChartLabelsFarsi: Label[] = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];
  // tslint:disable-next-line:max-line-length
  public lineChartLabelsEnglish: Label[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  public lineChartOptions: (ChartOptions & { annotation: any }) = {
    annotation: undefined,
    responsive: true,
    legend: {
      labels: {
        // fontFamily: 'IRANSansFarsi !important',
        // fontSize: 50,
      }
    }
  };
  public lineChartColors: Color[] = [];
  public lineChartLegend = true;
  public lineChartType: ChartType = 'line';
  public lineChartPlugins = [];
  // dooughnut
  public doughnutChartLabels: Label[] = [];
  public doughnutChartData: SingleDataSet = [];
  public doughnutChartType: ChartType = 'doughnut';
  constructor(private chartService: ChartService) {
  }

  ngOnInit(): void {
    this.isPremium = localStorage.getItem('isPremium');
    this.proVersion = this.isPremium;
    this.getBarChart();
    this.getWeekDoughtChart();
    this.getLineYearlyChart();
    Chart.defaults.global.defaultFontFamily = 'IRANSansFarsi !important';
    Chart.defaults.global.defaultFontSize = 20;
    if (localStorage.getItem('trans') === 'fa'){
    this.langMode = 'fa';
    } else if (localStorage.getItem('trans') === 'en'){
      this.langMode = 'en';
    }
  }
  getBarChart(): any{
    this.chartService.getBarWeeklyChart().subscribe(
      (data) => {
        this.thisWeek = data.data.map(obj => obj.this_week);
        this.lastWeek = data.data.map(obj => obj.last_week);
        this.average = data.data.map(obj => obj.average);
        if (this.langMode === 'fa'){
          this.barChartData.splice(0, 1);
          this.barChartData.push(
            {
              data: data.data.map(obj => obj.last_week),
              label: 'هفته گذشته',
              backgroundColor: '#578DFC'
            },
            {
              data: data.data.map(obj => obj.this_week),
              label: 'هفته جاری',
              backgroundColor: '#0932C2',
            },
            {
              data: data.data.map(obj => obj.average),
              label: 'میانگین',
              backgroundColor: '#F44728',
            }
          );
        }
        if (this.langMode === 'en'){
          this.barChartData.splice(0, 1);
          this.barChartData.push(
            {
              data: data.data.map(obj => obj.last_week),
              label: 'Last Week',
              backgroundColor: '#578DFC'
            },
            {
              data: data.data.map(obj => obj.this_week),
              label: 'This Week',
              backgroundColor: '#0932C2',
            },
            {
              data: data.data.map(obj => obj.average),
              label: 'Total Average',
              backgroundColor: '#F44728',
            }
          );
        }
        let thisTot = 0;
        let t;
        let thisAvg;
        for ( t = 0; t < this.thisWeek.length; t++){
          thisTot += this.thisWeek[t];
        }
        thisAvg = thisTot / this.thisWeek.length;
        this.thisWeekTotalAverage = thisAvg.toString().substr(0, 5);
        let lastTot = 0;
        let l;
        let lastAvg;
        for ( l = 0; l < this.lastWeek.length; l++){
          lastTot += this.lastWeek[l];
        }
        lastAvg = lastTot / this.lastWeek.length;
        this.lastsWeekTotalAverage = lastAvg.toString().substr(0 , 5);
        let avTot = 0;
        let a;
        let avgAvg;
        for ( a = 0; a < this.average.length; a++){
          avTot += this.average[a];
        }
        avgAvg = avTot / this.average.length;
        this.averageTotalAverage = avgAvg.toString().substr(0, 5);
      }
    );
  }
  getPieCategoryChart(): any{
    this.chartService.getPieCategoryChart().subscribe(
      (data) => {
        this.pieChartData = data.map(d => d.time);
        this.pieChartLabels = data.map(d => d.title);
      }
    );
  }
  getDoughtChart(): any{
    this.chartService.getPieCategoryChart().subscribe(
      (data) => {
        this.doughnutChartData = data.map(d => d.time);
        this.doughnutChartLabels = data.map(d => d.title);
      }
    );
  }
  onClick(check): any{
    if (check === 1){
      this.tab = 'tab1';
    }else if (check === 2){
      this.tab = 'tab2';
    }else if (check === 3){
      this.tab = 'tab3';
      }
  }
  getWeekDoughtChart(): any{
    this.chartService.getWeekPieCategoryChart().subscribe(
      (data) => {
        this.doughnutChartData = data.map(d => d.time);
        this.doughnutChartLabels = data.map(d => d.title);
      }
    );
  }
  getMonthDoughtChart(): any{
    this.chartService.getMonthPieCategoryChart().subscribe(
      (data) => {
        this.doughnutChartData = data.map(d => d.time);
        this.doughnutChartLabels = data.map(d => d.title);
      }
    );
  }
  getYearDoughtChart(): any{
    this.chartService.getYearPieCategoryChart().subscribe(
      (data) => {
        this.doughnutChartData = data.map(d => d.time);
        this.doughnutChartLabels = data.map(d => d.title);
      }
    );
  }
  getLineYearlyChart(): any{
    this.chartService.getLineYearlyChart().subscribe(
      (data) => {
        if (this.langMode === 'fa'){
          this.lineChartData.splice(0, 1);
          this.lineChartData.push(
            {
              data: Object.keys(data.data).map(index => {
                const myObj = data.data[index];
                return myObj;
              }),
              backgroundColor: '#0932C2',
              borderColor: '#0932C2',
              label: 'گزارش سالانه',
            }
          );
        }
        if (this.langMode === 'en'){
          this.lineChartData.splice(0, 1);
          this.lineChartData.push(
            {
              data: Object.keys(data.data).map(index => {
                const myObj = data.data[index];
                return myObj;
              }),
              backgroundColor: '#0932C2',
              borderColor: '#0932C2',
              label: 'Yearly Report',
            }
          );
        }
      }
    );
  }
}
